import ruQuestions from "./ru.json"
import enQuestions from "./en.json"
import frQuestions from "./fr.json"
import trQuestions from "./tr.json"
import deQuestions from "./de.json"

export const chatQuestions = {
  ru: ruQuestions,
  en: enQuestions,
  fr: frQuestions,
  tr: trQuestions,
  de: deQuestions,
}
